import * as React from 'react';

import { createRoot } from 'react-dom/client';

import { buildParticipation, buildProject, buildScreener } from '@api/builders';

import { GQSurvey } from './GQSurvey';

export function mount(): void {
  const el = document.getElementById('screener-form');
  if (!el) {
    return;
  }

  const data = JSON.parse(el.dataset.props || '{}');
  const props = {
    study: buildProject(data.study.data),
    screener: buildScreener(data.screener.data),
    participation: data.participation ? buildParticipation(data.participation.data) : undefined,
    consentCheckboxes: data.consent_checkboxes,
    hidden: data.hidden,
    prefill: data.prefill,
    account: data.account
  };

  const root = createRoot(el);
  root.render(React.createElement(GQSurvey, props));
}
